import { render, staticRenderFns } from "./AddressDeleteModal.vue?vue&type=template&id=c2fd0d6e&scoped=true&lang=pug&"
import script from "./AddressDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AddressDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressDeleteModal.vue?vue&type=style&index=0&id=c2fd0d6e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fd0d6e",
  null
  
)

export default component.exports